export enum InjectionMoldingOrderedProductStatus {
    Draft = 'Draft',
    Released = 'Released',
    Hold = 'Hold',
    ProductionComplete = 'Production Complete',
    /** Historical persisted value; displayed as Production Complete for compatibility. */
    ReadyToShip = 'Ready to Ship',
    Complete = 'Complete',
    Canceled = 'Canceled',
}

export function isInjectionMoldingProductionCompleteStatus(status: InjectionMoldingOrderedProductStatus): boolean {
    return status === InjectionMoldingOrderedProductStatus.ProductionComplete
        || status === InjectionMoldingOrderedProductStatus.ReadyToShip;
}

export function injectionMoldingOrderedProductStatusLabel(status: InjectionMoldingOrderedProductStatus): string {
    return isInjectionMoldingProductionCompleteStatus(status)
        ? InjectionMoldingOrderedProductStatus.ProductionComplete
        : status;
}
